import { AuthApi } from "@/api/auth";
import { LoginRequest } from "@/api/auth/types";
import { LocalStorageService } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotificationContext, useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";
import { useLoginPageStore } from "../context";

export const useLogin = ({
  goToSetPasswordStep,
}: {
  goToSetPasswordStep: () => void;
}) => {
  const { setAdminData } = useLoginPageStore();
  const queryClient = useQueryClient();
  const notify = useNotify();
  const navigate = useNavigate();
  const { resetNotifications } = useNotificationContext();

  const { mutate: login, isPending: isLoginLoading } = useMutation({
    mutationFn: (body: LoginRequest) => AuthApi.login(body),
    onSuccess: ({ admin, tokens }, { password }) => {
      resetNotifications();
      queryClient.invalidateQueries({
        queryKey: ["auth", "getPermissions"],
      });

      if (admin.isPasswordChangeRequired) {
        setAdminData({ admin, tokens, oldPassword: password });
        return goToSetPasswordStep();
      }

      LocalStorageService.setRefreshToken(tokens.refreshToken);
      LocalStorageService.setAccessToken(tokens.accessToken);
      navigate("/");
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return { login, isLoginLoading };
};
